<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Data Voucher Digital Reseller Detail
      </b-card-header>
      <b-card-body>
        <resellerDetail></resellerDetail>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import resellerDetail from './Table'

  export default {
    name: 'reseller-details',
    components: {
      resellerDetail
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
